import {
  AppRoute,
  buildPath,
  LanguageConfig,
} from '@agentselly/immodossier-shared';

export interface RouteParamsForSignOut {
  readonly lang?: string;
  readonly companyId?: string;
}

const isValidLang = (lang?: string): lang is string =>
  Boolean(
    lang &&
      LanguageConfig.availableLanguages.includes(lang) &&
      lang !== 'cimode',
  );

/**
 * Resolves the public login redirect URL after sign out.
 *
 * Preserves the active tenant's company ID and language so signing out
 * redirects to `/:lang/:companyId/public/auth/login` instead of falling back
 * to `/`, which would redirect to the environment's default company ID.
 */
export function getSignOutRedirectUrl(
  params?: RouteParamsForSignOut,
  fallbackPathname?: string,
): string {
  if (params?.companyId && /^\d+$/.test(params.companyId)) {
    const lang = isValidLang(params.lang)
      ? params.lang
      : LanguageConfig.fallbackLanguage;

    return buildPath(AppRoute.$LANG_$COMPANYID_PUBLIC_AUTH_LOGIN, {
      lang,
      companyId: params.companyId,
    });
  }

  const pathname =
    fallbackPathname ??
    (typeof window !== 'undefined' ? window.location.pathname : '');
  const parts = pathname.split('/').filter(Boolean);
  const pathLang = parts[0];
  const companyId = parts[1];

  if (companyId && /^\d+$/.test(companyId)) {
    const lang = isValidLang(pathLang)
      ? pathLang
      : LanguageConfig.fallbackLanguage;

    return buildPath(AppRoute.$LANG_$COMPANYID_PUBLIC_AUTH_LOGIN, {
      lang,
      companyId,
    });
  }

  return '/';
}
